module.exports = __webpack_public_path__ + "img/gift.35caf289.svg";